import { render, staticRenderFns } from "./UnauthAppLayout.vue?vue&type=template&id=511f086c&scoped=true&"
import script from "./UnauthAppLayout.js?vue&type=script&lang=js&"
export * from "./UnauthAppLayout.js?vue&type=script&lang=js&"
import style0 from "./UnauthAppLayout.scss?vue&type=style&index=0&id=511f086c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511f086c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VCard,VContainer,VMain,VNavigationDrawer})
